module.exports = __webpack_public_path__ + "img/mobukuEScrn1.532aafcf.png";